import {
  AnswerCreateDTO,
  FillInTheBlankOptionCreateDTO,
  QuestionCreateDTO,
  OrderingItemCreateDTO,
  PositionalAnswerCreateDTO,
  QuizAnswerCreateDTO,
} from '@/models/Answer';

const sanitizeMediaFile = (mediaFile: AnswerCreateDTO['mediaFile']) => {
  if (mediaFile instanceof File) return mediaFile;
  if (typeof mediaFile === 'string' && mediaFile !== '') return undefined;
  return '';
};

const sanitizeAnswer = ({
  id,
  text,
  mediaFile,
  altText,
}: AnswerCreateDTO): AnswerCreateDTO => ({
  id,
  text: text ?? undefined,
  mediaFile: sanitizeMediaFile(mediaFile),
  altText: altText ?? undefined,
});

export const sanitizeQuizAnswers = (answers: QuizAnswerCreateDTO[]) =>
  answers.map(({ isCorrect, ...answer }) => ({
    ...sanitizeAnswer(answer),
    isCorrect,
  }));

const sanitizeAnswersWithValidPositions = <T extends PositionalAnswerCreateDTO>(
  items: T[],
): T[] =>
  items.map(
    ({ validPositions, ...answer }) =>
      ({
        ...sanitizeAnswer(answer),
        validPositions,
      } as T),
  );

export const sanitizeOrderingAnswers = (items: OrderingItemCreateDTO[]) =>
  sanitizeAnswersWithValidPositions(items);

export const sanitizePositionalQuestions = (items: QuestionCreateDTO[]) =>
  items.map((item, index) => ({
    ...sanitizeAnswer(item),
    validPositions: [index + 1],
  }));

export const sanitizePositionalAnswers = (items: PositionalAnswerCreateDTO[]) =>
  sanitizeAnswersWithValidPositions(items);

export const sanitizeFillInTheBlankOptions = (
  options: FillInTheBlankOptionCreateDTO[],
) => sanitizeAnswersWithValidPositions(options);
